import constate from "constate";
import { useRef } from "react";
const useTableScrollerContext = () => {
  const scrollableRef = useRef(null);
  const scrollToItem = (rowIndex, columnIndex) => {
    var _a;
    (_a = scrollableRef == null ? void 0 : scrollableRef.current) == null ? void 0 : _a.scrollToItem({
      align: "smart",
      rowIndex,
      columnIndex
    });
  };
  const scrollToTop = () => {
    var _a;
    (_a = scrollableRef == null ? void 0 : scrollableRef.current) == null ? void 0 : _a.scrollTo({ scrollTop: 0 });
  };
  const scrollTo = (options) => {
    var _a;
    (_a = scrollableRef == null ? void 0 : scrollableRef.current) == null ? void 0 : _a.scrollTo(options ?? {});
  };
  return {
    scrollableRef,
    scrollToItem,
    scrollToTop,
    scrollTo
  };
};
const [TableScrollerProvider, useTableScroller] = constate(
  useTableScrollerContext
);
export {
  TableScrollerProvider,
  useTableScroller
};
